import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { KpiService } from "@gtmhub/kpis";
import { from, Subscription } from "rxjs";
import { ICollection } from "@gtmhub/models";
import { toNavItemsCollectionTransformer } from "@webapp/navigation/utils/nav-items.util";
import { INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { BaseRecentSubNav } from "../services/base-recent-sub-nav";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";

@Component({
  selector: "gh-kpis-sub-navigation",
  templateUrl: "./kpis-sub-navigation.component.html",
})
export class KpisSubNavigationComponent extends BaseRecentSubNav implements OnInit, OnDestroy {
  @Output() titleChange = new EventEmitter<string>();
  public options: SubNavOption[] = [
    // { label: "My KPIs", state: "gtmhub.kpis" },
    { label: "All KPIs", state: "gtmhub.kpis" },
  ];
  public favorites: ICollection<INavItem>;

  private kpisSubscription$: Subscription;
  private sectionTitle = "KPIs";

  constructor(private kpisService: KpiService, protected navigationItemsFacade: NavigationItemsFacade) {
    super();
    this.setupEntityTypes(["kpigroup"], "kpis");
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.titleChange.emit(this.sectionTitle);

    this.kpisSubscription$ = this.getKpis().subscribe((collection) => {
      this.favorites = collection;
    });
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.kpisSubscription$.unsubscribe();
  }

  // remove toNavItemsCollectionTransformer once we have a single view for kpis
  private getKpis() {
    const promise = this.kpisService.getKpis().then((collection) => toNavItemsCollectionTransformer(collection, "kpi"));

    return from(promise);
  }
}
